import { RoundedButton } from "generalComponents/Button";
import HeaderFooter from "generalComponents/HeaderFooter";
import TextGradient from "generalComponents/TextGradient";
import React, { useEffect, useState } from "react";
import AppointmentItem, {
  appointmentList,
} from "../components/AppointmentItem";
import DatePickerComponent from "generalComponents/DatePickerComponent";
import { useNavigate } from "react-router-dom";

const ScheduleAppointment = () => {
  const navigate = useNavigate();
  const [selected, setSelected] = useState();

  useEffect(() => {
    navigate("/");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <HeaderFooter>
      <TextGradient>Schedule Appointment</TextGradient>

      <div className="pt-[300px] pb-20 max-w-section mx-auto px-5">
        <h1 className="font-semibold text-[52px] lg:text-[60px] lg:leading-[70px] text-purpleOverlay mb-3">
          Schedule Appointment
        </h1>

        <div className="flex justify-between items-center mb-10">
          <h2 className="font-medium text-[30px] text-gray-300">
            My Appointment
          </h2>
          <RoundedButton className="py-3 px-5">
            + Make Appointment
          </RoundedButton>
        </div>

        <div className="grid lg:grid-cols-3">
          <div className="col-span-2 flex flex-col w-full gap-4">
            {appointmentList.map((item, index) => (
              <AppointmentItem key={index} {...item} />
            ))}
          </div>
          <div className="flex justify-end">
            <DatePickerComponent
              mode={"range"}
              selected={selected}
              onSelect={setSelected}
              disabledPeriod={(date) =>
                new Date(date).getTime() < new Date().getTime()
              }
            />
            {/* <div className=" px-5 py-4 w-fit text-black rounded-[10px] shadow-[0_10px_30px_0_#8311B326]">
              <DayPicker
                mode="single"
                selected={selected}
                onSelect={setSelected}
                disabledPeriod={(date) =>
                  new Date(date).getTime() < new Date().getTime()
                }
              />
            </div> */}
          </div>
        </div>
      </div>
    </HeaderFooter>
  );
};

export default ScheduleAppointment;
